import { isPlainObject, PlainObject } from './helpers';

const ADDED_SINCE_BUILD = Symbol('livePreviewBlockAddedSinceBuild');

export const markBlockAddedSinceBuild = (block: PlainObject): PlainObject => {
  block[ADDED_SINCE_BUILD as unknown as string] = true;

  return block;
};

export const isBlockAddedSinceBuild = (block: unknown): boolean =>
  isPlainObject(block) &&
  block[ADDED_SINCE_BUILD as unknown as string] === true;
